"use strict";

import Path from "pathjs";
import tablesort from "tablesort";
import {
    isEmpty,
    trimPipes,
    milOrBil,
    hasSection,
    generateRows,
    countEverything,
    convertToClass,
    getDefaultCoord,
    easeOutExpo,
    isTrueOrFalse,
    sanitize,
    removeDuplicates,
    removeDuplicateMarkers,
    getOS,
} from "../../_js/common/_util";
import { googleSheets, IS_PRODUCTION } from "../../_js/common/_variables";

import Company from "../company/company";
import Sidebar from "../sidebar/sidebar";
import Map from "../map/map";
import Filter from "../filter/filter";
import Model from "../model/model";
import TablePreview from "../table-preview/table-preview";
import MaterialDesign from "../../_js/common/_material-design";
import GaListeners from "../galisteners/gaListeners";

import Homepage from "../homepage/homepage";
import CompanyCard from "../company-card/company-card";
import DataListPage from "../data-list-page/data-list-page";
import DataListCard from "../data-list-card/data-list-card";

export default class Routes {
    constructor() {
        const self = this;

        // let _url =
        //     IS_PRODUCTION == true
        //         ? "/assets/chi-tech/json/api-chi-tech.json"
        //         : "https://cors-anywhere.herokuapp.com/http://uat.aspi.org.au/api-chi-tech";
        let _url = "/assets/chi-tech/json/api-chi-tech.json";

        self.filter = new Filter();
        self.material = new MaterialDesign();
        self.company = new Company();
        self.model = new Model();
        self.sidebar = new Sidebar();
        self.map = new Map();
        self.table = new TablePreview();
        self.gaListeners = new GaListeners();
        self.homepage = new Homepage();
        self.companyCard = new CompanyCard();
        self.dataListCard = new DataListCard();
        self.dataListPage = new DataListPage();

        self.body = $("body");
        self.view = $(".view .view__container");

        self.lastUpdated = "";
        self.newRelationsCountries = 0;
        self.relationsCount = 0;
        self.newSurveillanceCountries = 0;
        self.surveillanceCount = 0;
        self.newCompanyCountries = 0;
        self.newSmartCityCountries = 0;
        self.smartCityCount = 0;
        self.partnershipsCount = 0;
        self.rndLabsCount = 0;
        self.totalCount = 0;

        // Get the Last Updated date
        self.model.getData(googleSheets.last_update, (json) => {
            //     console.time('Parse Data')
            self.lastUpdated = json.data[0][0];
        });

        // get Menu and content of pages
        $.ajax({
            url: _url,
            crossDomain: true,
            success: function (res) {
                let navHTML = "";

                self.standardContent = res;
                res.forEach((v, i) => {
                    if (v.title != "Cables" && v.title != "Analysis") {
                        navHTML += `<li><a href="#${v.url}">${v.title}</a></li>`;
                    }
                });

                $(".main-navigation .-about ul").html(navHTML);
                $("#navigation .lvl1 > li:last-child").after(navHTML);

                self.initPath();

                $(".-js-download-csv").on("click", function (e) {
                    e.preventDefault();
                });
            },
            error: function (err) {
                console.error(err);
            },
        });
    }

    initPath() {
        const self = this;

        // Set the root of the site
        Path.root("#/homepage");

        // Company listing without params
        Path.map("#/companies")
            .enter(function () {
                self.updateAnalytics();
            })
            .to(function () {
                self.hideUI("companies");
            });

        Path.map("#/companies/")
            .enter(function () {
                self.updateAnalytics();
            })
            .to(function () {
                self.hideUI("companies");
            });

        // Homepage
        Path.map("#/homepage")
            .enter(function () {
                self.updateAnalytics();
            })
            .to(function () {
                self.hideUI("homepage");
            });

        Path.map("#/homepage/")
            .enter(function () {
                self.updateAnalytics();
            })
            .to(function () {
                self.hideUI("homepage");
            });

        //'/#/splash/' client's requirement

        Path.map("#/splash")
            .enter(function () {
                self.updateAnalytics();
            })
            .to(function () {
                self.hideUI("homepage");
            });
        Path.map("#/splash/")
            .enter(function () {
                self.updateAnalytics();
            })
            .to(function () {
                self.hideUI("homepage");
            });

        // Data list page
        Path.map("#/data")
            .enter(function () {
                self.updateAnalytics();
            })
            .to(function () {
                self.hideUI("data-list");
            });

        Path.map("#/data/")
            .enter(function () {
                self.updateAnalytics();
            })
            .to(function () {
                self.hideUI("data-list");
            });

        // Company Detail (with deeplink)
        Path.map("#/company/:param")
            .enter(function () {
                self.updateAnalytics();
            })
            .to(function () {
                $(".filter__btn.-filter").removeClass("-active");
                $(".filter__selections").slideUp(easeOutExpo);
                self.hideUI("detail", this.params.param);
            });

        Path.map("#/company/:param/")
            .enter(function () {
                self.updateAnalytics();
            })
            .to(function () {
                $(".filter__btn.-filter").removeClass("-active");
                $(".filter__selections").slideUp(easeOutExpo);
                self.hideUI("detail", this.params.param);
            });

        // Map
        Path.map("#/map")
            .enter(function () {
                self.updateAnalytics();
            })
            .to(function () {
                self.hideUI("map");
            });

        Path.map("#/map/")
            .enter(function () {
                self.updateAnalytics();
            })
            .to(function () {
                self.hideUI("map");
            });

        // Map with params
        Path.map("#/map/:param")
            .enter(function () {
                self.updateAnalytics();
            })
            .to(function () {
                self.hideUI("map-param", this.params.param);
            });

        Path.map("#/map/:param/")
            .enter(function () {
                self.updateAnalytics();
            })
            .to(function () {
                self.hideUI("map-param", this.params.param);
            });

        self.standardContent.forEach((v, i) => {
            let url = v.url.replace(/\//g, "");

            Path.map(`#/${url}`)
                .enter(function () {
                    self.hash = window.location.hash;
                    self.hashBrowns = self.hash.replace("#/", "");
                    self.hashBrowns = self.hashBrowns.replace("/", "");
                    self.updateAnalytics();
                })
                .to(function () {
                    self.hideUI(v.url, "dynamic");
                });

            Path.map(`#/${url}/`)
                .enter(function () {
                    self.hash = window.location.hash;
                    self.hashBrowns = self.hash.replace("#/", "");
                    self.hashBrowns = self.hashBrowns.replace("/", "");
                    self.updateAnalytics();
                })
                .to(function () {
                    self.hideUI(v.url, "dynamic");
                });

            Path.map(`#/${url}/:param`)
                .enter(function () {
                    self.hash = window.location.hash;
                    self.hashBrowns = url.replace("/", "");
                    self.updateAnalytics();
                })
                .to(function () {
                    self.hideUI(v.url, "dynamic", this.params.param);   
                });

            Path.map(`#/${url}/:param/`)
                .enter(function () {
                    self.hash = window.location.hash;
                    self.hashBrowns = url.replace("/", "");
                    self.updateAnalytics();
                })
                .to(function () {
                    self.hideUI(v.url, "dynamic", this.params.param);   
                });
        });

        // Contact Us
        Path.map("#/contact-us")
            .enter(function () {
                self.updateAnalytics();
            })
            .to(function () {
                self.hideUI("contact-us");
            });

        Path.map("#/contact-us/")
            .enter(function () {
                self.updateAnalytics();
            })
            .to(function () {
                self.hideUI("contact-us");
            });

        //Analysis page

        // Path.map(`#/analysis/:param`)
        //     .enter(function () {
        //         self.hash = window.location.hash;
        //         self.hashBrowns = self.hash.replace("#/", "");
        //         self.hashBrowns = self.hashBrowns.replace("/", "");
        //         self.updateAnalytics();
        //     })
        //     .to(function () {
        //         self.hideUI("analysis", "dynamic");
        //     });
        // Path.map(`#/analysis/:param/`)
        //     .enter(function () {
        //         self.hash = window.location.hash;
        //         self.hashBrowns = self.hash.replace("#/", "");
        //         self.hashBrowns = self.hashBrowns.replace("/", "");
        //         self.updateAnalytics();
        //     })
        //     .to(function () {
        //         self.hideUI("analysis", "dynamic");
        //     });

        //     self.standardContent.forEach((v, i) => {
        //     let url = v.url.replace(/\//g, "");

        //     Path.map(`#/${url}`)
        //         .enter(function () {
        //             self.hash = window.location.hash;
        //             self.hashBrowns = self.hash.replace("#/", "");
        //             self.hashBrowns = self.hashBrowns.replace("/", "");
        //             self.updateAnalytics();
        //         })
        //         .to(function () {
        //             self.hideUI(v.url, "dynamic");
        //         });

        //     Path.map(`#/${url}/`)
        //         .enter(function () {
        //             self.hash = window.location.hash;
        //             self.hashBrowns = self.hash.replace("#/", "");
        //             self.hashBrowns = self.hashBrowns.replace("/", "");
        //             self.updateAnalytics();
        //         })
        //         .to(function () {
        //             self.hideUI(v.url, "dynamic");
        //         });
        // });

        // TODO: 404
        Path.rescue(() => {});

        // Initialise SPA
        Path.listen();
    }

    hideUI(page, param = null, dynamicParam = null) {
        const self = this;

        $("html, body").animate(
            { scrollTop: 0},
            {
                duration: 1000,
                easing: "easeOutExpo",
            }
        );

        TweenLite.to(self.view, 0.5, {
            opacity: 0,
            ease: Expo.easeOut,
            onComplete: function () {
                self.view.removeClass("-column");
                self.body.removeClass("data-list-page");
                self.body.removeClass("-always-show-background");
                self.body.removeClass("-hide-footer");
                self.body.removeClass("map-page");
                self.body.removeClass("homepage");
                self.body.removeClass("standard");
                self.body.removeClass("company-detail");

                self.filter.resetFilter();
                self.map.killEvents();
            },
        });

        TweenLite.to(".view-loader", 0.5, {
            autoAlpha: 1,
            scale: 1,
            ease: Expo.easeOut,
            onComplete: function () {
                self.getPage(page, param, dynamicParam);
              
            },
        });
    }

    showUI() {
        const self = this;

        TweenLite.to(self.view, 1, {
            opacity: 1,
            ease: Expo.easeOut,
            delay: 0.5,
        });

        TweenLite.to(".view-loader", 1, {
            autoAlpha: 0,
            scale: 0.25,
            ease: Expo.easeOut,
        });
    }

    getPage(page, param = null, dyamicParam = null) {
        const self = this;

        switch (page) {
            case "companies":
                self.getCompanies();
                break;
            case "companies-param":
                self.getCompaniesParam(param);
                break;
            case "detail":
                self.getDetail(param);
                break;
            case "map":
                self.getMap();
                break;
            case "map-param":
                self.getMap(param);
                break;
            case "contact-us":
                self.getContactUs();
                break;
            case "homepage":
                self.getHomepage();
                break;
            case "data-list":
                self.getDataListPage();
                break;
            default:
                if (param == "dynamic") {
                    self.getStandard(dyamicParam);
                    
                } else {
                    self.getCompanies();
                }
                break;
        }
    }

    getStandard(param = null) {
        const self = this;
        let htmlTmpl = "";
        

        for (let i = 0, l = self.standardContent.length; i < l; i++) {
            if (self.standardContent[i].url.indexOf(self.hashBrowns) > -1) {
                htmlTmpl += `<div class="-standard col-6 col-offset-3" style="margin-top: 100px;">
                                ${self.standardContent[i].body}
                            </div>`;
                // htmlTmpl += `<main>
                //                 <div class="data-list-page__banner">
                //                     <div class="data-list-page__banner__body">
                //                         <h2>${self.standardContent[i].title}</h2>
                //                     </div>
                //                 </div>
                //             </main>
                //             <div class="-standard col-6 col-offset-3">
                //                 ${self.standardContent[i].body}
                //             </div>`;
            }
        }

        self.view.html(htmlTmpl);
        // self.body.addClass("-hide-filter");
        self.body.addClass("standard");
        self.showUI();
        var scrollDiv = document.getElementById(param).offsetTop - 100;
        $("html, body").animate(
            { scrollTop: scrollDiv},
            {
                duration: 1000,
                easing: "easeOutExpo",
            }
        ); 
    
      
    }

    getCompanies() {
        const self = this;

        self.getAllGoogleSheetData();

        const checkOtherModelTimer = setInterval(() => {
            if (
                self.model.companyModel.length > 0 &&
                self.model.areaOfBusinessModel.length > 0 &&
                self.model.overseasPresenceModel.length > 0 &&
                self.model.cableModel.length > 0 &&
                self.model.countriesModel.length > 0 &&
                self.model.regionsModel.length > 0
            ) {
                self.renderCompanies();
                clearInterval(checkOtherModelTimer);
            }
        }, 500);
    }

    getCompaniesParam(param) {
        const self = this;

        self.filter.setFilter(param);
        self.view.html(self.htmlTmpl);
        self.map.enableMapBtn();
        self.showUI();
    }

    getAllGoogleSheetData() {
        const self = this;

        // * Call the Companies Data
        if (self.model.companyModel.length === 0) {
            self.getCompaniesGoogleSheetData();
        }

        // * Call the other Data
        if (
            self.model.areaOfBusinessModel.length === 0 ||
            self.model.overseasPresenceModel.length === 0 ||
            self.model.cableModel.length === 0 ||
            self.model.countriesModel.length === 0 ||
            self.model.regionsModel.length === 0
        ) {
            self.getOtherDataGoogleSheetData();
        }
    }

    getOverseasPresenceGoogleSheetData() {
        const self = this;

        if (IS_PRODUCTION && getOS() !== "Mac OS" && getOS() !== "iOS") {
            if (localStorage.aspiLastUpdated != this.lastUpdated) {
                localStorage.removeItem("aspiModel");
            }
        } else {
            localStorage.removeItem("aspiModel");
        }

        if (localStorage.aspiModel == undefined) {
            self.model.getData(
                googleSheets.company_overseas_presence,
                (json) => {
                    self.model.overseasPresenceModel = json.data;
                }
            );
        } else {
            let _localStorageModel = JSON.parse(localStorage.aspiModel);

            self.model.overseasPresenceModel =
                _localStorageModel.overseasPresenceModel;
        }
    }

    getCompaniesGoogleSheetData() {
        const self = this;

        if (IS_PRODUCTION && getOS() !== "Mac OS" && getOS() !== "iOS") {
            if (localStorage.aspiLastUpdated != this.lastUpdated) {
                localStorage.removeItem("aspiModel");
            }
        } else {
            localStorage.removeItem("aspiModel");
        }

        if (localStorage.aspiModel == undefined) {
            self.model.getData(googleSheets.company, (json) => {
                self.model.companyModel = json.data;
            });
        } else {
            let _localStorageModel = JSON.parse(localStorage.aspiModel);

            self.model.companyModel = _localStorageModel.companyModel;
        }
    }

    getOtherDataGoogleSheetData() {
        const self = this;

        if (IS_PRODUCTION && getOS() !== "Mac OS" && getOS() !== "iOS") {
            if (localStorage.aspiLastUpdated != this.lastUpdated) {
                localStorage.removeItem("aspiModel");
            }
        } else {
            localStorage.removeItem("aspiModel");
        }

        if (localStorage.aspiModel == undefined) {
            self.model.getData(
                googleSheets.company_areas_of_business,
                (json) => {
                    self.model.areaOfBusinessModel = json.data;
                }
            );

            self.getOverseasPresenceGoogleSheetData();

            self.model.getData(googleSheets.company_cable_data, (json) => {
                self.model.cableModel = json.data;
            });

            self.model.getData(googleSheets.company_country, (json) => {
                self.model.countriesModel = json.data;
            });

            self.model.getData(googleSheets.company_region, (json) => {
                self.model.regionsModel = json.data;
            });
        } else {
            let _localStorageModel = JSON.parse(localStorage.aspiModel);

            self.model.companyModel = _localStorageModel.companyModel;
            self.model.areaOfBusinessModel =
                _localStorageModel.areaOfBusinessModel;
            self.model.overseasPresenceModel =
                _localStorageModel.overseasPresenceModel;
            self.model.cableModel = _localStorageModel.cableModel;
            self.model.countriesModel = _localStorageModel.countriesModel;
            self.model.regionsModel = _localStorageModel.regionsModel;
        }
    }

    getHomepage() {
        const self = this;
        const checkCompanyModelTimer = setInterval(() => {
            if (self.model.companyModel.length > 0) {
                self.renderHomepage();
                clearInterval(checkCompanyModelTimer);
            }
        }, 500);

        self.getCompaniesGoogleSheetData();
    }

    getDataListPage() {
        const self = this;

        self.getAllGoogleSheetData();

        const checkOtherModelTimer = setInterval(() => {
            if (
                self.model.companyModel.length > 0 &&
                self.model.areaOfBusinessModel.length > 0 &&
                self.model.overseasPresenceModel.length > 0 &&
                self.model.cableModel.length > 0 &&
                self.model.countriesModel.length > 0 &&
                self.model.regionsModel.length > 0
            ) {
                self.renderDataList();
                self.filter.init(self.map, self.model);
                clearInterval(checkOtherModelTimer);
            }
        }, 500);
    }

    getDetail(param = null) {
        const self = this;

        self.getAllGoogleSheetData();

        const checkOtherModelTimer = setInterval(() => {
            if (
                self.model.companyModel.length > 0 &&
                self.model.areaOfBusinessModel.length > 0 &&
                self.model.overseasPresenceModel.length > 0 &&
                self.model.cableModel.length > 0 &&
                self.model.countriesModel.length > 0 &&
                self.model.regionsModel.length > 0
            ) {
                self.renderCompanyDetail(param);
                clearInterval(checkOtherModelTimer);
            }
        }, 500);
    }

    getMap(param) {
        const self = this;

        self.getAllGoogleSheetData();

        const checkOtherModelTimer = setInterval(() => {
            if (
                self.model.companyModel.length > 0 &&
                self.model.areaOfBusinessModel.length > 0 &&
                self.model.overseasPresenceModel.length > 0 &&
                self.model.cableModel.length > 0 &&
                self.model.countriesModel.length > 0 &&
                self.model.regionsModel.length > 0
            ) {
                self.renderMap(param);
                self.filter.init(self.map, self.model);
                clearInterval(checkOtherModelTimer);
            }
        }, 500);
    }

    getContactUs() {
        const self = this;
        const htmlTmpl = `<div class="form col-6 col-offset-3">
                            <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfUw4Pus2d287o9chWpZVpCeO7ICgjjh1m9-BLMi76WYIGLLg/viewform?embedded=true" width="640" height="1093" frameborder="0" marginheight="0" marginwidth="0">Loading...</iframe>
                        </div>`;

        self.view.html(htmlTmpl);
        // self.body.addClass("-hide-filter");
        self.enableContactListeners();
        self.showUI();
    }

    renderHomepage() {
        const self = this;
        const companyCard = new CompanyCard();
        let companyCardHTML = "";

        self.view.html(self.homepage.generateHomepageHTML());
        // self.body.addClass("-hide-filter");
        self.body.addClass("homepage");

        // get company data
        // self.model.companyModel.sort(self.dynamicSort("3"));

        self.model.companyModel.forEach((el, i) => {
            if (
                isEmpty(el[3]) ||
                (el[1] === "type_of_company_id" &&
                    el[2] === "ownership_structure_id" &&
                    el[3] === "name")
            ) {
                return false;
            }

            companyCardHTML += companyCard.generateCompanyCardHTML(el);
        });

        // self.model.companyModel.forEach((el, i) => {
        //     if (i == 0 || isEmpty(el[3]) || i >= 9) {
        //         return false;
        //     }
        //     companyCardHTML += companyCard.generateCompanyCardHTML(el);
        // });

        $(".homepage-slides").html(companyCardHTML);

        $(".homepage-slides").slick({
            dots: true,
            infinite: true,
            centerPadding: "60px",
            slidesToShow: 3,
            slidesToScroll: 3,
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: true,
                        dots: true,
                    },
                },
                {
                    breakpoint: 426,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true,
                        variableWidth: true,
                    },
                },
            ],
        });

        // $(".company-card__header").matchHeight();
        // $(".company-card__details").matchHeight();
        // $(".company-card__info").matchHeight();

        $(".policy-card").matchHeight();

        $(".companies").hover(
            function () {
                $(this).html(
                    'Explore<span class="small-label">Companies</span><div class="plus-icon">+</div>'
                );
                $(this).addClass("onHover");
            },
            function () {
                $(this).html(
                    '<span>27</span>Tech Companies<div class="plus-icon">+</div>'
                );
                $(this).removeClass("onHover");
            }
        );

        $(".overseas-presence").hover(
            function () {
                $(this).html(
                    'Explore<span>Map</span><div class="plus-icon">+</div>'
                );
                $(this).addClass("onHover");
            },
            function () {
                $(this).html(
                    '<span>3800+</span>entries<div class="plus-icon">+</div>'
                );
                $(this).removeClass("onHover");
            }
        );

        $(".data-points").hover(
            function () {
                $(this).html(
                    'Explore<span>Data</span><div class="plus-icon">+</div>'
                );
                $(this).addClass("onHover");
            },
            function () {
                $(this).html(
                    '<span>186</span>Countries and Territories<div class="plus-icon">+</div>'
                );
                $(this).removeClass("onHover");
            }
        );

        $(".analysis").hover(
            function () {
                $(this).html(
                    'Explore<span>Analysis</span><div class="plus-icon">+</div>'
                );
                $(this).addClass("onHover");
            },
            function () {
                $(this).html(
                    '<span>8+</span>Research Products <div class="plus-icon">+</div>'
                );
                $(this).removeClass("onHover");
            }
        );

        self.showUI();
        self.getAllGoogleSheetData();
    }

    renderCompanies() {
        const self = this;
        let companyHTML = "";

        self.htmlTmpl = `<main id="main" class="-home -companies">
                                <section class="section -company">
                                    <div class="section-title"><h2>Company Briefs</h2></div>
                                    <div class="company__wrap">
                                        <div class="loader">
                                            <svg viewbox="25 25 50 50" class="circular">
                                                <circle cx="50" cy="50" r="18" fill="none" stroke-width="3" stroke-miterlimit="10" class="path"></circle>
                                            </svg>
                                        </div>
                                    </div>
                                </section>
                            </main>
                            `;

        self.view.html(self.htmlTmpl);
        // self.body.addClass("-hide-filter");
        self.body.addClass("-always-show-background");
        self.view.addClass("-column");

        // Init Homepage Company Summaries
        self.model.companyModel.sort(self.dynamicSort("3"));

        self.model.companyModel.forEach((el, i) => {
            if (
                isEmpty(el[3]) ||
                (el[1] === "type_of_company_id" &&
                    el[2] === "ownership_structure_id" &&
                    el[3] === "name")
            ) {
                return false;
            }

            companyHTML += self.company.generateCompanyHTML(el);
        });

        $(".section.-company .company__wrap").html(companyHTML);

        self.map.enableMapBtn();
        self.showUI();
    }

    renderCompanyDetail(param = null) {
        const self = this;

        // Find the selected company in the json
        let arrayPos = self.model.getPosInArr(self.model.companyModel, param);

        let selectedCompany = self.model.companyModel[arrayPos];

        let markersArr = [];
        let cablesArr = [];
        let cablesTerrestrialArr = [];
        let unknownArr = [];

        const type_of_company_id = trimPipes(selectedCompany[1]);
        const ownership_structure_id = trimPipes(selectedCompany[2]);
        const name = selectedCompany[3];
        const cn_name = selectedCompany[4];
        const net_worth = selectedCompany[5];
        const key_executive = selectedCompany[6];
        const logo = selectedCompany[8];
        const intro = selectedCompany[9];
        const overview = selectedCompany[10];
        const communist_party_activites = selectedCompany[13];
        const description_areas_of_global_business = selectedCompany[14];
        const description_overseas_infrastructure = selectedCompany[15];
        const xinjiang_activities = selectedCompany[17];
        const entity_list = selectedCompany[18];
        const covid = selectedCompany[19];
        const privacy = selectedCompany[20];

        // Areas of Business - 1
        let hasAreaOfBusiness = hasSection(
            self.model.areaOfBusinessModel,
            selectedCompany
        );

        // // Overseas Presence - 2
        // let hasOverseasPresence = hasSection(
        //     self.model.overseasPresenceModel,
        //     selectedCompany
        // );

        // Push Headquarters Location in Object
        // markersArr.push({
        //     label: name,
        //     company: name,
        //     country: {
        //         label: null,
        //         lat: Number(selectedCompany[11]),
        //         long: Number(selectedCompany[12]),
        //     },
        //     id: "hq-" + selectedCompany[0],
        //     properties: [type_of_company_id, ownership_structure_id, name],
        //     type: {
        //         label: "Headquarters",
        //         class: "headquarters",
        //     },
        // });

        // // Create Cable model
        // if (hasOverseasPresence) {
        //     // Overseas Presence - 2
        //     self.model.overseasPresenceModel.forEach((el, i) => {
        //         const id = trimPipes(el[0]);
        //         const company_id = trimPipes(el[1]);
        //         const infrastructure_type_id = trimPipes(el[2]);
        //         const secondary_infrastructure_type_id = trimPipes(el[3]);
        //         const country_id = trimPipes(el[4]);
        //         const city = trimPipes(el[5]);
        //         const overseas_infrastructure_lat = Number(el[6]);
        //         const overseas_infrastructure_lng = Number(el[7]);
        //         const label = trimPipes(el[8]);
        //         const year_commenced = trimPipes(el[9]);
        //         const primary_topic = trimPipes(el[11]);
        //         const secondary_topic = trimPipes(el[12]);
        //         const third_topic = trimPipes(el[13]);
        //         const text = trimPipes(el[14]);
        //         const cable_id = el[15];
        //         const highlight = isTrueOrFalse(el[16]);

        //         // Get cable and cable leased data
        //         if (
        //             !isEmpty(company_id) &&
        //             (infrastructure_type_id.toLowerCase() == "cable" ||
        //                 infrastructure_type_id.toLowerCase() ==
        //                     "cable (leased)")
        //         ) {
        //             self.model.cableModel.forEach((em, j) => {
        //                 if (cable_id == em[0]) {
        //                     cablesArr.push({
        //                         id: id,
        //                         company: company_id,
        //                         color: em[4],
        //                         lease: em[9],
        //                         length: em[6],
        //                         owner: em[8],
        //                         isHighlighted: highlight,
        //                         name: em[3],
        //                         points: JSON.parse(em[2]),
        //                         properties: [
        //                             company_id,
        //                             infrastructure_type_id,
        //                             secondary_infrastructure_type_id,
        //                             country_id,
        //                             primary_topic,
        //                             secondary_topic,
        //                             third_topic,
        //                         ],
        //                         rfs: em[7],
        //                         routes: em[5],
        //                         text: em[11],
        //                     });
        //                 }
        //             });
        //         } else if (
        //             !isEmpty(company_id) &&
        //             trimPipes(infrastructure_type_id.toLowerCase()) ==
        //                 "cable terrestrial" &&
        //             sanitize(trimPipes(company_id.toLowerCase())) == param
        //         ) {
        //             self.model.cableModel.forEach((em, j) => {
        //                 if (
        //                     cable_id == em[0] &&
        //                     param == convertToClass(trimPipes(cable_id))
        //                 ) {
        //                     cablesTerrestrialArr.push({
        //                         id: id,
        //                         company: company_id,
        //                         color: em[4],
        //                         lease: em[9],
        //                         length: em[6],
        //                         owner: em[8],
        //                         isHighlighted: highlight,
        //                         name: em[3],
        //                         points: JSON.parse(em[2]),
        //                         properties: [
        //                             company_id,
        //                             infrastructure_type_id,
        //                             secondary_infrastructure_type_id,
        //                             country_id,
        //                             primary_topic,
        //                             secondary_topic,
        //                             third_topic,
        //                         ],
        //                         rfs: em[7],
        //                         routes: em[5],
        //                         text: em[11],
        //                     });
        //                 }
        //             });

        //             if (
        //                 param == trimPipes(company_id) &&
        //                 trimPipes(infrastructure_type_id.toLowerCase()) ==
        //                     "cable terrestrial" &&
        //                 !isEmpty(overseas_infrastructure_lat) &&
        //                 !isEmpty(overseas_infrastructure_lng) &&
        //                 isEmpty(cable_id)
        //             ) {
        //                 markersArr.push({
        //                     company: company_id,
        //                     country: {
        //                         label: country_id,
        //                         lat: overseas_infrastructure_lat,
        //                         long: overseas_infrastructure_lng,
        //                     },
        //                     id: id,
        //                     isHighlighted: highlight,
        //                     label: label,
        //                     properties: [
        //                         company_id,
        //                         infrastructure_type_id,
        //                         secondary_infrastructure_type_id,
        //                         country_id,
        //                         primary_topic,
        //                         secondary_topic,
        //                         third_topic,
        //                     ],
        //                     text: el[12],
        //                     text: text,
        //                     type: {
        //                         label: infrastructure_type_id,
        //                         class: infrastructure_type_id.toLowerCase(),
        //                         year: year_commenced,
        //                     },
        //                 });
        //             }
        //         } else {
        //             if (
        //                 i > 0 &&
        //                 !isEmpty(infrastructure_type_id) &&
        //                 !isEmpty(country_id) &&
        //                 isEmpty(overseas_infrastructure_lat) &&
        //                 isEmpty(overseas_infrastructure_lat) &&
        //                 !isEmpty(text) &&
        //                 sanitize(trimPipes(el[1].toLowerCase())) == param
        //             ) {
        //                 if (unknownArr.length == 0) {
        //                     unknownArr = [
        //                         {
        //                             country: {
        //                                 label: country_id,
        //                                 city: city,
        //                                 lat: getDefaultCoord({
        //                                     country: country_id,
        //                                     model: self.model,
        //                                     type: "lat",
        //                                 }),
        //                                 long: getDefaultCoord({
        //                                     country: country_id,
        //                                     model: self.model,
        //                                     type: "lng",
        //                                 }),
        //                             },
        //                             id: [id],
        //                             markersArr: [
        //                                 {
        //                                     company: company_id,
        //                                     label: label,
        //                                     text: text,
        //                                     type: {
        //                                         label: infrastructure_type_id,
        //                                         class: infrastructure_type_id.toLowerCase(),
        //                                     },
        //                                 },
        //                             ],
        //                             properties: [
        //                                 company_id,
        //                                 infrastructure_type_id,
        //                                 secondary_infrastructure_type_id,
        //                                 country_id,
        //                                 primary_topic,
        //                                 secondary_topic,
        //                                 third_topic,
        //                             ],
        //                         },
        //                     ];
        //                 } else {
        //                     for (let i = 0, l = unknownArr.length; i < l; i++) {
        //                         if (unknownArr[i].country.label == country_id) {
        //                             unknownArr[i].id.push(id);
        //                             unknownArr[i].markersArr.push({
        //                                 company: company_id,
        //                                 label: label,
        //                                 text: text,
        //                                 type: {
        //                                     label: infrastructure_type_id,
        //                                     class: infrastructure_type_id.toLowerCase(),
        //                                 },
        //                             });
        //                             return false;
        //                         }
        //                     }

        //                     unknownArr.push({
        //                         company: company_id,
        //                         country: {
        //                             label: country_id,
        //                             city: city,
        //                             lat: getDefaultCoord({
        //                                 country: country_id,
        //                                 model: self.model,
        //                                 type: "lat",
        //                             }),
        //                             long: getDefaultCoord({
        //                                 country: country_id,
        //                                 model: self.model,
        //                                 type: "lng",
        //                             }),
        //                         },
        //                         id: [id],
        //                         markersArr: [
        //                             {
        //                                 company: company_id,
        //                                 label: label,
        //                                 text: text,
        //                                 type: {
        //                                     label: infrastructure_type_id,
        //                                     class: infrastructure_type_id.toLowerCase(),
        //                                 },
        //                             },
        //                         ],
        //                         properties: [
        //                             company_id,
        //                             infrastructure_type_id,
        //                             secondary_infrastructure_type_id,
        //                             country_id,
        //                             primary_topic,
        //                             secondary_topic,
        //                             third_topic,
        //                         ],
        //                     });
        //                 }
        //             } else if (
        //                 i > 0 &&
        //                 !isEmpty(infrastructure_type_id) &&
        //                 !isEmpty(overseas_infrastructure_lat) &&
        //                 !isEmpty(overseas_infrastructure_lng) &&
        //                 !isEmpty(text) &&
        //                 sanitize(company_id.toLowerCase()) == param
        //             ) {
        //                 markersArr.push({
        //                     company: company_id,
        //                     country: {
        //                         label: country_id,
        //                         lat: overseas_infrastructure_lat,
        //                         long: overseas_infrastructure_lng,
        //                     },
        //                     id: id,
        //                     isHighlighted: highlight,
        //                     label: label,
        //                     properties: [
        //                         company_id,
        //                         infrastructure_type_id,
        //                         secondary_infrastructure_type_id,
        //                         country_id,
        //                         primary_topic,
        //                         secondary_topic,
        //                         third_topic,
        //                     ],
        //                     text: text,
        //                     type: {
        //                         label: infrastructure_type_id,
        //                         class: infrastructure_type_id.toLowerCase(),
        //                         year: year_commenced,
        //                     },
        //                 });
        //             }
        //         }
        //     });

        //     self.map.setOverseasPresenceModel(self.model.overseasPresenceModel);
        //     self.map.setCableModel(cablesArr);
        //     self.map.setTerrestrialCableModel(cablesTerrestrialArr);
        //     self.filter.setMarkers(markersArr);
        // }

        // Compile all data
        let htmlTmpl = `<main id="main" class="-detail">`;

        if (!isEmpty(overview.trim())) {
            htmlTmpl += `   <section id="overview" class="section">
                    <h1 class="sr-only">${name} (${cn_name})</h1>
                    <h2>Overview</h2>
                    ${overview}
                </section>`;
        }

        // Areas of Business
        if (!isEmpty(description_areas_of_global_business.trim())) {
            htmlTmpl += `   <section id="areas-of-overseas-business" class="section">
                    <h2>Areas of Overseas Business Activity</h2>

                    ${description_areas_of_global_business}

                </section>`;
        }

        // Party-state Activities
        if (!isEmpty(communist_party_activites.trim())) {
            htmlTmpl += `   <section id="party-state-activities" class="section">
                    <h2>Party-state Activities</h2>
                    ${communist_party_activites}
                </section>`;
        }

        // xinjiang_activities
        if (!isEmpty(xinjiang_activities.trim())) {
            htmlTmpl += `         <section id="activities-in-xianjiang" class="section">
                    <h2>Activities in Xinjiang</h2>
                    ${xinjiang_activities}
                </section>`;
        }

        // privacy
        if (!isEmpty(privacy.trim())) {
            htmlTmpl += `         <section id="privacy" class="section">
                    <h2>Privacy Policies</h2>
                    ${privacy}
                </section>`;
        }

        // covid
        if (!isEmpty(covid.trim())) {
            htmlTmpl += `         <section id="covid" class="section">
                    <h2>Covid-19 Impact</h2>
                    ${covid}
                </section>`;
        }

        // // Overseas Presence
        // if (hasOverseasPresence) {
        //     htmlTmpl += `   <section id="overseas-presence" class="section">
        //             <h2>Overseas Presence</h2>
        //             ${description_overseas_infrastructure}
        //             <table>
        //                 <thead>
        //                     <tr>
        //                         <th width="140px">Infrastructure</th>
        //                         <th width="140px">Location</th>
        //                         <th width="100px">Year</th>
        //                         <th>Description</th>
        //                     </tr>
        //                 </thead>
        //                 <tbody>`;

        //     htmlTmpl += generateRows({
        //         data: {
        //             numCol: 4,
        //             datum: self.model.overseasPresenceModel,
        //             pos: [2, 4, 5, 9, 14],
        //             toTrim: [true, true],
        //         },
        //         array: selectedCompany,
        //     });

        //     htmlTmpl += `           <tbody>
        //             </table>
        //         </section>`;
        // }

        htmlTmpl += `       <div id="map" class="map"></div>
                <div class="share">
                    <ul>
                        <li>
                        <button type="button" class="-shareLink"><span class="sr-only">Copy the Link</span></button>
                        </li>
                        <li>
                            <button type="button" class="-facebook"><span class="sr-only">Share to Facebook</span></button>
                        </li>
                        <li>
                            <button type="button" class="-twitter"><span class="sr-only">Tweet to Twitter</span></button>
                        </li>
                    </ul>
                    <h2>Share</h2>
                </div>
                <!--button class="map-button -js-explore-map" type="button"><span class="sr-only">Explore</span>Map</button-->
            </main>
            <aside class="aside sidebar" data-sticky-container>
                <div class="sidebar__wrap">
                    <a href="#/companies/" class="sidebar__btn">View all companies</a>
                    <div class="sidebar__logo">${logo}</div>






            <div class=nameAndmarker>    <div class="sidebar__header">${name}</div>
                    <!-- <div class="sidebar__header">${name} <span>(${cn_name})</span></div> -->`;

        //if (!isEmpty(el[0])) {
        htmlTmpl += `<div ><span class="data-list-card__map-link"><a href="#/map/f2-${name}" title="Show pin on map">map link</a></span> </div></div>`;
        //}
        htmlTmpl += `            <p>${intro}</p>`;

        // Sidebar information
        if (
            !isEmpty(type_of_company_id) ||
            !isEmpty(ownership_structure_id) ||
            !isEmpty(net_worth) ||
            !isEmpty(key_executive)
        ) {
            htmlTmpl += `       <ul class="sidebar__info">`;

            if (!isEmpty(net_worth)) {
                htmlTmpl += `       <li class="-networth"><div>Market value</div>${milOrBil(
                    net_worth
                )} USD</li>`;
            }

            if (!isEmpty(type_of_company_id)) {
                htmlTmpl += `       <li class="-type"><div>Type of company</div>${type_of_company_id}</li>`;
            }

            if (!isEmpty(key_executive)) {
                if (!isEmpty(selectedCompany[7])) {
                    htmlTmpl += `   <li class="-ceo"><div>Founder / CEO</div>${key_executive} (${selectedCompany[7]})</li>`;
                } else {
                    htmlTmpl += `   <li class="-ceo">${key_executive}</li>`;
                }
            }

            if (!isEmpty(ownership_structure_id)) {
                htmlTmpl += `       <li class="-ownership"><div>Ownership structure</div>${ownership_structure_id}</li>`;
            }

            htmlTmpl += `       </ul>`;
        }

        htmlTmpl += `           <div class="sidebar__sticky" data-margin-top="40" data-sticky-wrap="true">
                        <ul class="sidebar__sections">`;

        if (!isEmpty(overview.trim())) {
            htmlTmpl += `               <li class="-active"><a class="-js-scroll-to" href="#overview">Overview</a></li>`;
        }

        if (!isEmpty(description_areas_of_global_business.trim())) {
            htmlTmpl += `               <li><a class="-js-scroll-to" href="#areas-of-overseas-business">Areas of Overseas Business Activity</a></li>`;
        }

        if (!isEmpty(communist_party_activites.trim())) {
            htmlTmpl += `               <li><a class="-js-scroll-to" href="#party-state-activities">Party-state Activities</a></li>`;
        }

        if (!isEmpty(xinjiang_activities.trim())) {
            htmlTmpl += `               <li><a class="-js-scroll-to" href="#activities-in-xianjiang">Activities in Xinjiang</a></li>`;
        }

        if (!isEmpty(privacy.trim())) {
            htmlTmpl += `               <li><a class="-js-scroll-to" href="#privacy">Privacy Policies</a></li>`;
        }

        if (!isEmpty(covid.trim())) {
            htmlTmpl += `               <li><a class="-js-scroll-to" href="#covid">Covid-19 Impact</a></li>`;
        }

        // if (hasOverseasPresence) {
        //     htmlTmpl += `               <li><a class="-js-scroll-to" href="#overseas-presence">Overseas Presence</a></li>`;
        // }

        htmlTmpl += `                </ul>
                        <button class="downloadable-pdf-button -js-print-page">Print</button>
                    </div>
                </aside>`;

        self.view.html(htmlTmpl);
        self.body.addClass("company-detail");
        self.table.initTablePreview();
        self.sidebar.stick();
        self.showUI();

        $(".downloadable-pdf-button").off("click");
        $(".downloadable-pdf-button").on("click", function () {
            window.print();
        });

        // Show/Hide Toggle Button
        // $("#main.-detail .section").each(function (i, v) {
        //     let $this = $(v);
        //     let $table = $this.find("table");

        //     if ($this.outerHeight() < 350) {
        //         $this.addClass("-show");
        //     }

        //     if ($table.length > 0) {
        //         tablesort($table[0]);
        //     }
        // });

        // // Add Event Listener
        // $(".-js-toggle-section").on("click", function (e) {
        //     e.preventDefault();

        //     const $this = $(this);
        //     const $section = $this.closest(".section");

        //     $section.toggleClass("-expand");

        //     if ($section.hasClass("-expand")) {
        //         $this.text("Collapse");
        //     } else {
        //         $this.text("Expand");
        //     }
        // });
    }

    renderMap(param = null) {
        const self = this;

        let markersArr = [];
        let cablesArr = [];
        let cablesTerrestrialArr = [];
        let cablesTerrestrialMarkersArr = [];
        let unknownArr = [];
        let dataPointCount = 0;
        window.companyIndex = [];

        self.model.companyModel.forEach((el, i) => {
            if (
                i > 0 &&
                !isEmpty(el[1]) &&
                !isEmpty(el[3]) &&
                !isEmpty(el[11]) &&
                !isEmpty(el[12])
            ) {
                markersArr.push({
                    company: trimPipes(el[1]),
                    country: {
                        label: null,
                        lat: Number(el[11]),
                        long: Number(el[12]),
                    },
                    id: "hq-" + el[0],
                    label: el[3],
                    properties: [trimPipes(el[1]), trimPipes(el[2]), el[3]],
                    text: el[9],
                    logo: el[8],
                    type: {
                        label: "Headquarters",
                        class: "headquarters",
                    },
                });
                window.companyIndex[trimPipes(el[3]).toLowerCase()] = el[8];
            }
        });

        // Overseas Presence - 2
        self.model.overseasPresenceModel.forEach((el, i) => {
            const id = trimPipes(el[0]);
            const company_id = trimPipes(el[1]);
            const infrastructure_type_id = trimPipes(el[2]);
            const secondary_infrastructure_type_id = trimPipes(el[3]);
            const country_id = trimPipes(el[4]);
            const city = trimPipes(el[5]);
            const overseas_infrastructure_lat = Number(el[6]);
            const overseas_infrastructure_lng = Number(el[7]);
            const label = trimPipes(el[8]);
            const year_commenced = trimPipes(el[9]);
            const primary_topic = trimPipes(el[11]);
            const secondary_topic = trimPipes(el[12]);
            const third_topic = trimPipes(el[13]);
            const text = trimPipes(el[14]);
            const cable_id = el[15];
            const highlight = isTrueOrFalse(el[16]);

            if (
                !isEmpty(id) &&
                !isEmpty(company_id) &&
                !isEmpty(infrastructure_type_id)
            ) {
                dataPointCount += 1;
            }

            // Get cable and cable leased data
            if (
                !isEmpty(company_id) &&
                (infrastructure_type_id.toLowerCase() == "cable" ||
                    infrastructure_type_id.toLowerCase() == "cable (leased)")
            ) {
                self.model.cableModel.forEach((em, j) => {
                    if (cable_id == em[0]) {
                        cablesArr.push({
                            id: id,
                            company: company_id,
                            color: em[4],
                            lease: em[9],
                            length: em[6],
                            owner: em[8],
                            isHighlighted: highlight,
                            name: em[3],
                            points: JSON.parse(em[2]),
                            properties: [
                                company_id,
                                infrastructure_type_id,
                                secondary_infrastructure_type_id,
                                country_id,
                                primary_topic,
                                secondary_topic,
                                third_topic,
                            ],
                            rfs: em[7],
                            routes: em[5],
                            text: em[11],
                        });
                    }
                });
            } else if (
                !isEmpty(company_id) &&
                trimPipes(infrastructure_type_id.toLowerCase()) ==
                    "cable terrestrial"
            ) {
                self.model.cableModel.forEach((em, j) => {
                    if (cable_id == em[0]) {
                        cablesTerrestrialArr.push({
                            id: id,
                            company: company_id,
                            color: em[4],
                            lease: em[9],
                            length: em[6],
                            owner: em[8],
                            isHighlighted: highlight,
                            name: em[3],
                            points: JSON.parse(em[2]),
                            properties: [
                                company_id,
                                infrastructure_type_id,
                                secondary_infrastructure_type_id,
                                country_id,
                                primary_topic,
                                secondary_topic,
                                third_topic,
                            ],
                            rfs: em[7],
                            routes: em[5],
                            text: em[11],
                        });
                    }
                });

                if (
                    trimPipes(infrastructure_type_id.toLowerCase()) ==
                        "cable terrestrial" &&
                    !isEmpty(overseas_infrastructure_lat) &&
                    !isEmpty(overseas_infrastructure_lng) &&
                    isEmpty(cable_id)
                ) {
                    cablesTerrestrialMarkersArr.push({
                        markerCoor: `${overseas_infrastructure_lat},${overseas_infrastructure_lng}`,
                        company: company_id,
                        country: {
                            label: country_id,
                            lat: overseas_infrastructure_lat,
                            long: overseas_infrastructure_lng,
                        },
                        id: id,
                        isHighlighted: highlight,
                        label: label,
                        properties: [
                            company_id,
                            infrastructure_type_id,
                            secondary_infrastructure_type_id,
                            country_id,
                            primary_topic,
                            secondary_topic,
                            third_topic,
                        ],
                        text: text,
                        type: {
                            label: infrastructure_type_id,
                            class: infrastructure_type_id.toLowerCase(),
                            year: year_commenced,
                        },
                    });
                }
            } else {
                if (
                    i > 0 &&
                    !isEmpty(infrastructure_type_id) &&
                    !isEmpty(country_id) &&
                    isEmpty(overseas_infrastructure_lat) &&
                    isEmpty(overseas_infrastructure_lat) &&
                    !isEmpty(text)
                ) {
                    if (unknownArr.length == 0) {
                        unknownArr = [
                            {
                                country: {
                                    label: country_id,
                                    city: city,
                                    lat: getDefaultCoord({
                                        country: country_id,
                                        model: self.model,
                                        type: "lat",
                                    }),
                                    long: getDefaultCoord({
                                        country: country_id,
                                        model: self.model,
                                        type: "lng",
                                    }),
                                },
                                id: [id],
                                markersArr: [
                                    {
                                        company: company_id,
                                        label: label,
                                        text: text,
                                        type: {
                                            label: infrastructure_type_id,
                                            class: infrastructure_type_id.toLowerCase(),
                                        },
                                    },
                                ],
                                properties: [
                                    company_id,
                                    infrastructure_type_id,
                                    secondary_infrastructure_type_id,
                                    country_id,
                                    primary_topic,
                                    secondary_topic,
                                    third_topic,
                                ],
                            },
                        ];
                    } else {
                        for (let i = 0, l = unknownArr.length; i < l; i++) {
                            if (unknownArr[i].country.label == country_id) {
                                unknownArr[i].id.push(id);
                                unknownArr[i].markersArr.push({
                                    company: company_id,
                                    label: label,
                                    text: text,
                                    type: {
                                        label: infrastructure_type_id,
                                        class: infrastructure_type_id.toLowerCase(),
                                    },
                                });
                                return false;
                            }
                        }

                        unknownArr.push({
                            company: company_id,
                            country: {
                                label: country_id,
                                city: city,
                                lat: getDefaultCoord({
                                    country: country_id,
                                    model: self.model,
                                    type: "lat",
                                }),
                                long: getDefaultCoord({
                                    country: country_id,
                                    model: self.model,
                                    type: "lng",
                                }),
                            },
                            id: [id],
                            markersArr: [
                                {
                                    company: company_id,
                                    label: label,
                                    text: text,
                                    type: {
                                        label: infrastructure_type_id,
                                        class: infrastructure_type_id.toLowerCase(),
                                    },
                                },
                            ],
                            properties: [
                                company_id,
                                infrastructure_type_id,
                                secondary_infrastructure_type_id,
                                country_id,
                                primary_topic,
                                secondary_topic,
                                third_topic,
                            ],
                        });
                    }
                } else if (
                    i > 0 &&
                    !isEmpty(infrastructure_type_id) &&
                    !isEmpty(overseas_infrastructure_lat) &&
                    !isEmpty(overseas_infrastructure_lng) &&
                    !isEmpty(text)
                ) {
                    markersArr.push({
                        company: company_id,
                        country: {
                            label: country_id,
                            lat: overseas_infrastructure_lat,
                            long: overseas_infrastructure_lng,
                        },
                        id: id,
                        isHighlighted: highlight,
                        label: label,
                        properties: [
                            company_id,
                            infrastructure_type_id,
                            secondary_infrastructure_type_id,
                            country_id,
                            primary_topic,
                            secondary_topic,
                            third_topic,
                        ],
                        text: text,
                        type: {
                            label: infrastructure_type_id,
                            class: infrastructure_type_id.toLowerCase(),
                            year: year_commenced,
                        },
                    });
                }
            }
        });

        cablesTerrestrialMarkersArr = removeDuplicateMarkers(
            cablesTerrestrialMarkersArr,
            "markerCoor"
        );

        cablesTerrestrialMarkersArr.forEach((val, ind) => {
            markersArr.push(val);
        });

        self.map.setOverseasPresenceModel(self.model.overseasPresenceModel);
        self.map.setCableModel(cablesArr);
        self.map.setTerrestrialCableModel(cablesTerrestrialArr);
        self.filter.setMarkers(markersArr);

        // Compile all data                    <a href="#/data" class="list-view-btn">List VIEW</a>

        let htmlTmpl = `<main id="main" class="-map">
                            <div class="map-page__content__header">
                                <div class="data-result">
                                    <span class="data-results-title">DATA RESULTS</span>
                                    <span class="data-results-number">0</span>
                                    <div class="data-results-wrap">
                                        <div class="data-results-control">
                                            <button class="filters-expand-btn">Filter</button>
                                            <button class="filters-clear-all-btn">CLEAR ALL</button>
                                            <button class="filters-close-btn">Close</button>
                                        </div>
                                        <div class="data-results-filters"></div>
                                    </div>
                                    <div class="right-col">
                                        <a href="https://docs.google.com/spreadsheets/d/${googleSheets.urlID}/gviz/tq?tqx=out:csv&gid=1003963993&tq=select%20*" class="download-results-btn">DOWNLOAD RESULTS</a>
                                    </div>
                                    <button class="filter__btn -js-toggle-filter">
                                        Filter
                                    </button>
                                </div>
                            </div>
                            <section id="overview" class="section">
                                <h1 class="sr-only">Global map</h1>

                                <div class="filter">
                                    <ul class="filter__buttons">
                                        <li class="filter__controls">
                                            <div class="filter__button -filter">Filter</div>
                                            <button type="button" aria-label="Reset" class="filter__button -reset -js-reset-filter">Reset</button>
                                            <div class="filter__msg"></div>
                                        </li>
                                        <li class="form-item -toggle"><span>show Our Highlights only<i title="Our Highlights are data points of particular interest where we have undertaken additional analysis." class="icon"></i></span>
                                            <label class="switch">
                                            <input type="checkbox" name="ourHighlights" value="f0-ourHighlights"/><span class="slider round"></span>
                                            </label>
                                        </li>
                                        <li>
                                            <button type="button" aria-label="Country" class="filter__button -country -js-toggle-buttons">Country</button>
                                            <div class="filter__selection -country">
                                            <input id="filter-country" type="text" placeholder="Filter" aria-label="Filter by country"/>
                                            <div class="filter__scroll"></div>
                                            </div>
                                        </li>
                                        <li>
                                            <button type="button" aria-label="Company" class="filter__button -company -js-toggle-buttons">Company</button>
                                            <div class="filter__selection -company">
                                            <input id="filter-company" type="text" placeholder="Filter" aria-label="Filter by company"/>
                                            <div class="filter__scroll"></div>
                                            </div>
                                        </li>
                                        <li>
                                            <button type="button" aria-label="Type of company" class="filter__button -type-of-company -js-toggle-buttons">Type of company</button>
                                            <div class="filter__selection -type-of-company">
                                            <div class="filter__scroll"></div>
                                            </div>
                                        </li>
                                        <li>
                                            <button type="button" aria-label="Ownership structure" class="filter__button -ownership -js-toggle-buttons">Ownership structure</button>
                                            <div class="filter__selection -ownership">
                                            <div class="filter__scroll"></div>
                                            </div>
                                        </li>
                                        <li>
                                            <button type="button" aria-label="Overseas Presence" class="filter__button -overseasPresence -js-toggle-buttons">Overseas Presence</button>
                                            <div class="filter__selection -overseasPresence">
                                            <div class="filter__scroll"></div>
                                            </div>
                                        </li>
                                        <li>
                                            <button type="button" aria-label="Topics" class="filter__button -topics -js-toggle-buttons">Topics</button>
                                            <div class="filter__selection -topics">
                                            <div class="filter__scroll"></div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                <div class="legend">
                                    <button type="button" class="legend__btn -js-toggle-legend">
                                        <span class="sr-only">Toggle map legend</span>
                                    </button>

                                    <div class="legend__wrap">
                                        <h2>Map Legend</h2>

                                        <div class="legend__scroll">
                                            <ul class="legend__data">`;

        let finalCount = [];
        // let cableCountArr = [];
        // let cableTerrestrialCountArr = [];
        // let cableTerrestrialCount = 0;

        self.totalCount = 0;
        finalCount = countEverything(self.model.overseasPresenceModel, 2);
        if (finalCount.length > 0) {
            finalCount.forEach((el, i) => {
                if (el.label == "") {
                    return false;
                }

                htmlTmpl += `       <li class="-${convertToClass(el.label)}">${
                    el.label
                }</li>`;

                // if (el.label == "Manufacturing facility") {
                //     htmlTmpl += `       ${el.value} Manufacturing facilities`;
                // } else if (el.label == "Cable") {
                //     self.model.overseasPresenceModel.forEach((em, i) => {
                //         if (trimPipes(em[2]) == "Cable") {
                //             cableCountArr.push(em[15]);
                //         }
                //     });
                //     cableCountArr = removeDuplicates(cableCountArr);
                //     htmlTmpl += `       ${cableCountArr.length} Cables`;
                // } else if (el.label == "Cable Terrestrial") {
                //     let cableTerrestrialMarkerArr = [];
                //     self.model.overseasPresenceModel.forEach((em, i) => {
                //         // Count how many Cable Terrestrial cables(s) present
                //         if (
                //             (trimPipes(em[2]) == "Cable Terrestrial" ||
                //                 trimPipes(em[3]) == "Cable Terrestrial") &&
                //             !isEmpty(em[13])
                //         ) {
                //             cableTerrestrialCountArr.push(em[15]);
                //         }

                //         // Count how many Cable Terrestrial markers present
                //         if (
                //             (trimPipes(em[2]) == "Cable Terrestrial" ||
                //                 trimPipes(em[3]) == "Cable Terrestrial") &&
                //             isEmpty(em[13])
                //         ) {
                //             cableTerrestrialMarkerArr.push(
                //                 `${Number(em[6])},${Number(em[7])}`
                //             );
                //         }
                //     });

                //     // Remove duplicate cable markers
                //     cableTerrestrialMarkerArr = removeDuplicates(
                //         cableTerrestrialMarkerArr
                //     );

                //     // Remove duplicate cable names
                //     cableTerrestrialCountArr = removeDuplicates(
                //         cableTerrestrialCountArr
                //     );

                //     // 1...2...3...cable points...ah ah ah!
                //     cableTerrestrialCount =
                //         cableTerrestrialCountArr.length +
                //         cableTerrestrialMarkerArr.length;

                //     htmlTmpl += `       ${cableTerrestrialCount} Cables Terrestrial`;
                // } else if (el.label == "Subsidiary") {
                //     htmlTmpl += `       ${el.value} Subsidiaries`;
                // } else {
                //     htmlTmpl += `       ${el.value} ${el.label}s`;
                // }

                // * START: counting crows
                // if (el.label == "Manufacturing facility") {
                //     htmlTmpl += `       ${el.value} Manufacturing facilities`;
                // } else if (el.label == "Cable") {
                //     self.model.overseasPresenceModel.forEach((em, i) => {
                //         if (trimPipes(em[2]) == "Cable") {
                //             cableCountArr.push(em[15]);
                //         }
                //     });
                //     cableCountArr = removeDuplicates(cableCountArr);
                //     htmlTmpl += `       ${cableCountArr.length} Cables`;
                // } else if (el.label == "Cable Terrestrial") {
                //     let cableTerrestrialMarkerArr = [];
                //     self.model.overseasPresenceModel.forEach((em, i) => {
                //         // Count how many Cable Terrestrial cables(s) present
                //         if (
                //             (trimPipes(em[2]) == "Cable Terrestrial" ||
                //                 trimPipes(em[3]) == "Cable Terrestrial") &&
                //             !isEmpty(em[13])
                //         ) {
                //             cableTerrestrialCountArr.push(em[15]);
                //         }

                //         // Count how many Cable Terrestrial markers present
                //         if (
                //             (trimPipes(em[2]) == "Cable Terrestrial" ||
                //                 trimPipes(em[3]) == "Cable Terrestrial") &&
                //             isEmpty(em[13])
                //         ) {
                //             cableTerrestrialMarkerArr.push(
                //                 `${Number(em[6])},${Number(em[7])}`
                //             );
                //         }
                //     });

                //     // Remove duplicate cable markers
                //     cableTerrestrialMarkerArr = removeDuplicates(
                //         cableTerrestrialMarkerArr
                //     );

                //     // Remove duplicate cable names
                //     cableTerrestrialCountArr = removeDuplicates(
                //         cableTerrestrialCountArr
                //     );

                //     // 1...2...3...cable points...ah ah ah!
                //     cableTerrestrialCount =
                //         cableTerrestrialCountArr.length +
                //         cableTerrestrialMarkerArr.length;

                //     htmlTmpl += `       ${cableTerrestrialCount} Cables Terrestrial`;
                // } else if (el.label == "Subsidiary") {
                //     htmlTmpl += `       ${el.value} Subsidiaries`;
                // } else {
                //     htmlTmpl += `       ${el.value} ${el.label}s`;
                // }
                // * END: counting crows

                htmlTmpl += `       </li>`;
            });
        }

        htmlTmpl += `                       </ul>
                                        </div>
                                    </div>
                                </div>

                                <div id="map" class="map -show"></div>
                            </section>
                        </main>`;

        self.view.html(htmlTmpl);
        self.map.buildMap(markersArr, unknownArr);
        self.body.addClass("-hide-footer");
        self.body.addClass("map-page");
        self.body.addClass("-always-show-background");

        $(".data-results-number").text(dataPointCount);
        $(".legend__scroll").mCustomScrollbar({
            advanced: {
                updateOnContentResize: true,
            },
        });

        if (param != undefined) {
            setTimeout(() => {
                if (param.indexOf("cable-terrestrial-marker") > -1) {
                    self.map.findMarker(param, "cable-terrestrial-marker");
                } else if (param.indexOf("marker") > -1) {
                    self.map.findMarker(param, "marker");
                } else {
                    self.filter.setFilter(param);
                }
            }, 750);
        }

        $(".-js-toggle-legend").off("click");
        $(".-js-toggle-legend").on("click", function (e) {
            const $this = $(this);
            const $next = $this.next();

            $this.toggleClass("-showLegend");

            if ($this.hasClass("-showLegend")) {
                $next.stop().clearQueue().slideDown(easeOutExpo);
            } else {
                $next.stop().clearQueue().slideUp(easeOutExpo);
            }
        });

        $(".-js-toggle-filter").off("click");
        $(".-js-toggle-filter").on("click", function () {
            $(".filter").stop().clearQueue().slideToggle(easeOutExpo);
        });

        $(".filters-expand-btn").off("click");
        $(".filters-expand-btn").on("click", function () {
            $(".data-results-wrap").addClass("-floating");
        });

        $(".filters-close-btn").off("click");
        $(".filters-close-btn").on("click", function () {
            $(".data-results-wrap").removeClass("-floating");
        });

        $(".filters-clear-all-btn").off("click");
        $(".filters-clear-all-btn").on("click", function (e) {
            e.preventDefault();

            $(".filter input[type='checkbox']").prop("checked", false);
            $(".data-results-wrap").removeClass("-enabled");
            $(".data-results-wrap").removeClass("-floating");
            $(".data-results-filters").html("");
        });

        self.showUI();
    }

    renderDataList() {
        console.time("renderDataList");
        const self = this;

        self.view.html(self.dataListPage.generateDataListPageHTML());
        self.body.addClass("data-list-page");
        self.body.addClass("-always-show-background");

        // Init Homepage Company Summaries
        let dataListCardHTML = "";
        let dataPointCount = 1;

        self.model.overseasPresenceModel.forEach((el, i) => {
            if (i == 0) {
                return false;
            }

            if (!isEmpty(el[0]) && !isEmpty(el[1]) && !isEmpty(el[2])) {
                dataPointCount += 1;
            }

            dataListCardHTML += self.dataListCard.generateDataListCardHTML(el);
        });

        $(".data-list-page__content__body__content").html(dataListCardHTML);

        $(".data-results-number").text(dataPointCount);

        // $(".-js-toggle-filter").off("click");
        $(".-js-toggle-filter").on("click", function () {
            $(".filter").stop().clearQueue().slideToggle(easeOutExpo);
        });

        // $(".filters-expand-btn").off("click");
        $(".filters-expand-btn").on("click", function () {
            $(".data-results-wrap").addClass("-floating");
        });

        // $(".filters-close-btn").off("click");
        $(".filters-close-btn").on("click", function () {
            $(".data-results-wrap").removeClass("-floating");
        });

        // $(".filters-clear-all-btn").off("click");
        $(".filters-clear-all-btn").on("click", function (e) {
            e.preventDefault();

            $(".filter input[type='checkbox']").prop("checked", false);
            $(".data-results-wrap").removeClass("-enabled");
            $(".data-results-wrap").removeClass("-floating");
            $(".data-results-filters").html("");
        });

        // $(".data-list-card__description").each(function () {
        //     if ($(this).height() > 50) {
        //         $(this).addClass("collapsed");
        //         $(this).prepend(
        //             '<button class="data-list-card-expand-btn">expand/collapse</button>'
        //         );
        //     }
        // });

        $(".data-list-card-expand-btn").click(function () {
            $(this).parent().toggleClass("collapsed");
        });

        console.timeEnd("renderDataList");

        self.showUI();
    }

    enableContactListeners() {
        $("#edit-field-i-want-to").on("change", function (e) {
            e.preventDefault();

            let value = this.value;
            if (value == "Submit a new data point") {
                $(".data-point").stop().clearQueue().slideDown(easeOutExpo);
            } else {
                $(".data-point").stop().clearQueue().slideUp(easeOutExpo);
            }
            $(".feedback, .form-actions")
                .stop()
                .clearQueue()
                .slideDown(easeOutExpo);
        });
    }

    updateAnalytics() {
        this.gaListeners.gaPageView();
    }

    /**
     * Function to sort alphabetically an array of objects by some specific key.
     *
     * @param {String} property Key of the object to sort.
     */
    dynamicSort(property) {
        var sortOrder = 1;

        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }

        return function (a, b) {
            if (sortOrder == -1) {
                return b[property].localeCompare(a[property]);
            } else {
                return a[property].localeCompare(b[property]);
            }
        };
    }
}
